import axios from 'axios';
import { PapiroConsole } from '../utils/papiroConsole';

let saasError = false
try {
  const urlSaaS = process.env.REACT_APP_API+"/hirerconfig/geturl/"+window.location.host+"/1";
  PapiroConsole.log(urlSaaS)
  var xhttp = new XMLHttpRequest();
  xhttp.open("GET", urlSaaS, false);
  xhttp.send();
  PapiroConsole.log(JSON.parse(xhttp.responseText));
} catch(e) {
  PapiroConsole.log(e)
  PapiroConsole.log("urlSaaS")
  if(e.name == "NetworkError") {
    PapiroConsole.log("entrou NetworkError")
    if(e.message.indexOf("Failed to execute 'send' on 'XMLHttpRequest'") !== -1) {
      saasError = true;
      PapiroConsole.log("entrou Failed 'send' 'XMLHttpRequest'")
    }else if(e.message.indexOf("A network error occurred.") !== -1) {
      saasError = true;
      PapiroConsole.log("entrou em A network error occurred.")
    }else {
      PapiroConsole.log("Outro erro")
      PapiroConsole.log(e.name)
      PapiroConsole.log(e.message)
    }
  }
}

let Api2Talk = {};
let baseURLBack = {};


if(!saasError) {
  
  let baseUrlResponse = JSON.parse(xhttp.responseText);

  if(baseUrlResponse && baseUrlResponse.data && (baseUrlResponse.data.urlapicone || baseUrlResponse.data.urlapi2talkservice)) {
    let baseURL = "";
    if(baseUrlResponse.data.urlapicone){
      baseURL = "https://"+baseUrlResponse.data.urlapicone+"/api";
    }
    else{
      baseURL = "https://"+baseUrlResponse.data.urlapi2talkservice+"/api";
    }
    const token = localStorage.getItem('accesstoken2talk');
    baseURLBack = baseURL;

    Api2Talk = axios.create({
      baseURL: baseURL,
      headers: { 
        'Content-Type': 'application/json', 
        'Access-Control-Allow-Origin': '*',  
        'Authorization': `Bearer ${token}` 
      },
    });

   
  }
}

Api2Talk.apiurlbase = function () {
  return baseURLBack;
}


export default Api2Talk;
